import React from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import CompactSection from 'src/presentation/components/pages/integrations/editorComponents/CompactSection';
import { Row } from 'src/presentation/components/forms/Layout';
import {
  WrappedField,
  MaskedField,
} from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';

function renderSegmentConfiguration(onChange: (attr: string) => ChangeHandler, maskedFields: string[]): JSX.Element {
  return (
    <>
      <CompactSection
        description={`The Gladly-Segment integration enables you to segment customers in Segment based on whether the customer is engaged in a support conversation in Gladly.`}
      >
        <Row>
          <WrappedField
            attr="name"
            label="Name"
            placeholder="App Name"
            description="This is the name that will be displayed throughout Gladly"
            data-aid="segment-integration-name"
            autoFocus={true}
            onChange={onChange('name')}
          />
        </Row>

        <MaskedField
          attr="secrets.token"
          label="Segment Private Key"
          description="This is the private key used to authenticate your Segment requests"
          data-aid="segment-token"
          onChange={onChange('secrets.token')}
          showClearButton={maskedFields.includes('token')}
          isMasked={maskedFields.includes('token')}
        />
      </CompactSection>
    </>
  );
}

export default renderSegmentConfiguration;
